import { actionable } from '@github/catalyst/lib/actionable'

// AVAL Sign — Bannette / Historique sidebar interactions.
//
// Pattern : Custom Element + @github/catalyst `actionable` decorator.
// Identique aux autres elements DocuSeal (turbo_modal, toggle_visible, etc.).
//
// Avantages vs <script> inline :
//   - JS bundlé via webpack -> pas de souci CSP nonce
//   - connectedCallback / disconnectedCallback = lifecycle natif
//   - Survit Turbo navigation (le browser gere la registration)
//   - data-action="event:tagname#method" = handlers declaratifs propres
//
// Usage HTML :
//   <aval-bannette class="...">
//     <button data-action="click:aval-bannette#toggle"
//             data-aval-hamburger>☰</button>
//     <div data-aval-drawer-overlay
//          data-action="click:aval-bannette#closeOnOverlay"></div>
//     <aside data-aval-drawer>
//       <button data-action="click:aval-bannette#close"
//               data-aval-drawer-close>✕</button>
//     </aside>
//   </aval-bannette>
export default actionable(class extends HTMLElement {
  connectedCallback () {
    this.onEscKey = (e) => { if (e.key === 'Escape' && this.isOpen) this.close() }
    this.onResize = () => {
      if (this.isOpen && window.innerWidth >= 768) this.close()
    }
    this.onBeforeCache = () => { if (this.isOpen) this.close() }

    document.addEventListener('keydown', this.onEscKey)
    window.addEventListener('resize', this.onResize)
    document.addEventListener('turbo:before-cache', this.onBeforeCache)
  }

  disconnectedCallback () {
    document.removeEventListener('keydown', this.onEscKey)
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('turbo:before-cache', this.onBeforeCache)
    document.body.style.overflow = ''
  }

  get isOpen () {
    return this.querySelector('[data-aval-drawer]')?.classList.contains('open') || false
  }

  toggle () {
    this.isOpen ? this.close() : this.open()
  }

  open () {
    const drawer = this.querySelector('[data-aval-drawer]')
    const overlay = this.querySelector('[data-aval-drawer-overlay]')
    if (!drawer) return

    drawer.classList.add('open')
    overlay?.classList.add('open')
    document.body.style.overflow = 'hidden'

    this.querySelectorAll('[data-aval-hamburger]').forEach(b => {
      b.classList.add('is-open')
      b.setAttribute('aria-expanded', 'true')
    })

    this.querySelector('[data-aval-drawer-close]')?.focus()
  }

  close () {
    const drawer = this.querySelector('[data-aval-drawer]')
    const overlay = this.querySelector('[data-aval-drawer-overlay]')
    if (!drawer) return

    drawer.classList.remove('open')
    overlay?.classList.remove('open')
    document.body.style.overflow = ''

    this.querySelectorAll('[data-aval-hamburger]').forEach(b => {
      b.classList.remove('is-open')
      b.setAttribute('aria-expanded', 'false')
    })
  }

  // Ferme uniquement si on tape directement sur l'overlay (pas un enfant).
  closeOnOverlay (event) {
    if (event.target === event.currentTarget) this.close()
  }
})
